<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">HORRORSCOPES</h1>
<p class="center">A Little Book of Misfortunes</p>
<p class="white1"></p>
<h3 class="author">by Lucien Edwards</h3>
<h3 class="author">Illustrations by Eugene Smith</h3>
<p class="white1"></p>
<div class="image" id="image1">
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?6a9b6804